import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export const fadeUp = { hidden: { opacity: 0, y: 24 }, visible: { opacity: 1, y: 0 } };

const FadeIn = ({ children, className = '', id, delay = 0, as = 'section' }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.08, rootMargin: '-30px' });
  const Component = as === 'div' ? motion.div : motion.section;

  return (
    <Component
      id={id}
      ref={ref}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      variants={fadeUp}
      transition={{ duration: 0.6, delay, ease: [0.25, 0.1, 0.25, 1] }}
      className={className}
    >
      {children}
    </Component>
  );
};

export default FadeIn;
